module.exports = __webpack_public_path__ + "static/media/register2.bc88fd16.png";